import React, { useEffect, useState } from 'react'
import './side-menu.styles.scss'

import { Link, useLocation, useNavigate } from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCertificate, faChartPie, faCode, faGear, faHourglass3, faMouse, faNetworkWired, faUser, faUsersBetweenLines } from '@fortawesome/free-solid-svg-icons';
import { setReqTab } from './toggle-items';
import { useSelector } from 'react-redux';

const SideMenuUser = () => {

  const userProfile = useSelector(state => state.userData.userProfile);
  const navigate = useNavigate();
  const location = useLocation();
  const [showReqDrop, setShowReqDrop] = useState(false)

  useEffect(() => {
    if (location.pathname.includes('req-')) {
      setShowReqDrop(true);
    } else {
      setShowReqDrop(false);
      setReqTab();
    }
  }, [location.pathname])


  return (
    <div className="admin-menu-container">
      <Link to='/admin'>
        <div className={`side-menu-item ${location.pathname == '/admin' && 'active'}`}>
          <div className='menu-item-icon'>
            <FontAwesomeIcon icon={faCertificate} size='xl' />
          </div>
          Manage MCs
        </div>
      </Link>
      <Link to='/admin/users'>
        <div className={`side-menu-item ${location.pathname.includes('/admin/users') && 'active'}`} >
          <div className='menu-item-icon'>
            <FontAwesomeIcon icon={faUser} size='xl' />
          </div>
          Manage Users
        </div>
      </Link>
      <Link to='/admin/pendingmcs'>
        <div className={`side-menu-item ${location.pathname.includes('/admin/pendingmcs') && 'active'}`}>
          <div className='menu-item-icon'>
            <FontAwesomeIcon icon={faHourglass3} size='xl' />
          </div>
          Pending MCs
        </div>
      </Link>
      <Link to='/admin/data'>
        <div className={`side-menu-item ${location.pathname.includes('/admin/data') && 'active'}`}>
          <div className='menu-item-icon'>
            <FontAwesomeIcon icon={faChartPie} size='xl' />
          </div>
          Usage Data
        </div>
      </Link>
      <Link to='/admin/cohorts'>
        <div className={`side-menu-item ${location.pathname.includes('/admin/cohorts') && 'active'}`}>
          <div className='menu-item-icon'>
            <FontAwesomeIcon icon={faUsersBetweenLines} size='xl' />
          </div>
          Manage Cohorts
        </div>
      </Link>
      <Link to='/admin/settings'>
        <div className={`side-menu-item ${location.pathname.includes('/admin/settings') && 'active'}`}>
          <div className='menu-item-icon'>
            <FontAwesomeIcon icon={faGear} size='xl' />
          </div>
          Settings
        </div>
      </Link>

      {
        (userProfile && userProfile.email === 'adam.geisen@ilprincipals.org') &&
        <Link to='/admin/functions'>
          <div className={`side-menu-item ${location.pathname.includes('/admin/functions') && 'active'}`} >
            <div className='menu-item-icon'>
              <FontAwesomeIcon
                icon={faCode}
                size='xl' />
            </div>
            Admin Functions
          </div>
        </Link>
      }
      <Link to='/admin/apikeys'>
        <div className={`side-menu-item ${location.pathname.includes('/admin/apikeys') && 'active'}`} >
          <div className='menu-item-icon'>
            <FontAwesomeIcon
              icon={faNetworkWired}
              size='xl' />
          </div>
          API Keys
        </div>
      </Link>
      <Link to='/admin/activity'>
        <div className={`side-menu-item ${location.pathname.includes('/admin/activity') && 'active'}`}>
          <div className='menu-item-icon'>
            <FontAwesomeIcon icon={faMouse} size='xl' />
          </div>
          Activity Logs
        </div>
      </Link>

    </div>
  )
}

export default SideMenuUser